
export const monthPickerHandler = (parent, nextElement = null, cb = null) => {
  const picker = parent.querySelector('[data-month-picker]');
  if (!picker) return;

  const selectedItem = picker.querySelector('div[selected]');
  cb?.(selectedItem.getAttribute('data-value'));

  picker.addEventListener('click', (e) => {
    e.preventDefault();

    const targetElement = e.target.closest('div[data-value]');

    if (targetElement) {
      const selectedItem = picker.querySelector('div[selected]');
      selectedItem.removeAttribute('selected');
      targetElement.setAttribute('selected', '');
      const value = targetElement.getAttribute('data-value');

      cb?.(value);
    }
  });

  picker.addEventListener('keydown', (e) => {
    const targetElement = e.target.closest('div[data-value]');

    if (!targetElement) return;

    if (e.key === 'Enter' || e.key === ' ') {
      const selectedItem = picker.querySelector('div[selected]');
      selectedItem.removeAttribute('selected');

      e.target.setAttribute('selected', '');
      const value = e.target.getAttribute('data-value');

      cb?.(value);

      if (nextElement) {
        nextElement?.focus();
      }
    }

    if (e.key === 'Tab' && document.activeElement === picker?.children[picker?.children?.length - 1]) {
      e.preventDefault();
      picker?.children?.[0].focus();
    }
  });

};
